import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getAuthoringScheduleRecommendations = api(async function authoringScheduleRecommendations({
    projectId,
    scheduleId,
    sourceFilter,
}) {
    if (!projectId || !scheduleId) return []

    return query(
        gql`
            query GetAuthoringScheduleRecommendations(
                $projectId: String!
                $scheduleId: String!
                $sourceFilter: String
            ) {
                authoringScheduleRecommendations(
                    projectId: $projectId
                    scheduleId: $scheduleId
                    sourceFilter: $sourceFilter
                )
            }
        `,
        { projectId, scheduleId, sourceFilter },
        { returns: "authoringScheduleRecommendations" }
    )
})
